import React from 'react';
import {
  AlertOutlined,
  AuditOutlined,
  BarsOutlined,
  BorderOutlined,
  CheckOutlined,
  CloseCircleOutlined,
  CloudUploadOutlined,
  ContainerOutlined,
  ControlOutlined,
  EditOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  FlagOutlined,
  FolderViewOutlined,
  FundOutlined,
  FundViewOutlined,
  GlobalOutlined,
  HomeOutlined,
  IdcardOutlined,
  InfoCircleOutlined,
  PlusCircleOutlined,
  ProductOutlined,
  ReconciliationOutlined,
  SaveOutlined,
  SendOutlined,
  StopOutlined,
  SyncOutlined,
  TeamOutlined,
  ThunderboltOutlined,
  ToolOutlined,
  UserOutlined,
} from '@ant-design/icons';

import {
  TASK_TYPE_GROUP,
  TASK_TYPE_MILESTONE,
  TASK_TYPE_TASK,
} from '@totem/components/ticketing/ticketing';
import {
  AdvancedThreatIcon,
  CveIcon,
  DataProtectIcon,
  ExploitIcon,
  HyperDetectIcon,
  LinkIcon,
  MalwareIcon,
  NetworkAttackIcon,
  RansomwareIcon,
  StarOutlinedIcon,
  StarSolidIcon,
  StorageMalwareIcon,
  TaskListIcon,
  TeamFilled,
  TicketTypeChangeRequest,
  TicketTypeIncident,
  TicketTypeProblem,
  TicketTypeProject,
  TicketTypeServiceRequest,
} from '@totem/styles/customIcons';

type Props = {
  name: string;
  title?: string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
};
// forwardRef so IBDIcon works as a direct child of Tooltip / Popover /
// Dropdown, which attach a ref to their child to position and trigger
const IBDIcon = React.forwardRef<HTMLSpanElement, Props>(
  ({ name, style, className, onClick, title }, ref) => {
    const commonProps = {
      ref,
      style,
      className,
      onClick,
      title,
    };

    const getIcon = () => {
      switch (name) {
        case 'Portfolio':
          return <FundOutlined {...commonProps} />;
        case 'Refresh':
          return <SyncOutlined {...commonProps} />;
        case 'Dashboard':
          return <HomeOutlined {...commonProps} />;
        case 'Organization':
          return <GlobalOutlined {...commonProps} />;
        case 'Region':
          return <IdcardOutlined {...commonProps} />;
        case 'Building':
          return <EnvironmentOutlined {...commonProps} />;
        case 'Control System':
          return <ToolOutlined {...commonProps} />;
        case 'Device':
          return <ToolOutlined {...commonProps} />;
        case 'Policy Audit':
          return <AuditOutlined {...commonProps} />;
        case 'Policy':
          return <ControlOutlined {...commonProps} />;
        case 'Finding':
          return <InfoCircleOutlined {...commonProps} />;
        case 'Survey':
          return <FileTextOutlined {...commonProps} />;
        case 'Survey Template':
          return <BarsOutlined {...commonProps} />;
        case 'Event':
          return <AlertOutlined {...commonProps} />;
        case 'Asset Inventory':
          return <FolderViewOutlined {...commonProps} />;
        case 'Software':
          return <ProductOutlined {...commonProps} />;
        case 'Backups':
          return <CloudUploadOutlined {...commonProps} />;
        case 'Remote Access':
          return <IdcardOutlined {...commonProps} />;
        case 'Ticket':
          return <ReconciliationOutlined {...commonProps} />;
        case 'User':
          return <UserOutlined {...commonProps} />;
        case 'Users':
          return <TeamOutlined {...commonProps} />;
        case 'UsersFilled':
          return <TeamFilled {...commonProps} />;
        case 'Malware':
          return <MalwareIcon {...commonProps} />;
        case 'Network Attack':
          return <NetworkAttackIcon {...commonProps} />;
        case 'Ransomware':
          return <RansomwareIcon {...commonProps} />;
        case 'Storage Malware':
          return <StorageMalwareIcon {...commonProps} />;
        case 'Hyper Detect':
          return <HyperDetectIcon {...commonProps} />;
        case 'Data Protection':
          return <DataProtectIcon {...commonProps} />;
        case 'Exploit':
          return <ExploitIcon {...commonProps} />;
        case 'Advanced Threat':
          return <AdvancedThreatIcon {...commonProps} />;
        case 'CVE':
          return <CveIcon {...commonProps} />;
        case 'Add':
          return <PlusCircleOutlined {...commonProps} />;
        case 'Save':
          return <SaveOutlined {...commonProps} />;
        case 'Cancel':
          return <StopOutlined {...commonProps} />;
        case 'Edit':
          return <EditOutlined {...commonProps} />;
        case 'Delete':
          return <CloseCircleOutlined {...commonProps} />;
        case 'EndOfSupport':
          return <ThunderboltOutlined {...commonProps} />;
        case 'StarOutlined':
          return <StarOutlinedIcon {...commonProps} />;
        case 'StarSolid':
          return <StarSolidIcon {...commonProps} />;
        case 'Change Request':
          return <TicketTypeChangeRequest {...commonProps} />;
        case 'Incident':
          return <TicketTypeIncident {...commonProps} />;
        case 'Problem':
          return <TicketTypeProblem {...commonProps} />;
        case 'Project':
          return <TicketTypeProject {...commonProps} />;
        case 'Optimize':
          return <FundViewOutlined {...commonProps} />;
        case 'Site Project':
          return <TicketTypeProject {...commonProps} />;
        case 'Service Request':
          return <TicketTypeServiceRequest {...commonProps} />;
        case 'HR':
          return <UserOutlined {...commonProps} />;
        case 'Information':
          return <InfoCircleOutlined {...commonProps} />;
        case 'Contract':
          return <ContainerOutlined {...commonProps} />;
        case TASK_TYPE_TASK:
        case 'task':
          return <CheckOutlined {...commonProps} />;
        //return <TaskIcon {...commonProps} />;
        case TASK_TYPE_GROUP:
        case 'group':
          return <TaskListIcon {...commonProps} />;
        case TASK_TYPE_MILESTONE:
        case 'milestone':
        case 'Milestone':
          return <FlagOutlined {...commonProps} />;
        case 'Link':
          return <LinkIcon {...commonProps} />;
        case 'Send':
          return <SendOutlined {...commonProps} />;
        default:
          return <BorderOutlined {...commonProps} />;
      }
    };

    return getIcon();
  },
);

IBDIcon.displayName = 'IBDIcon';

export default IBDIcon;
